// @ts-nocheck
import _ from 'lodash';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import { EmptyState } from '../../../../../common/components';
import ActivityList from '../common/ActivityList';
import ActivityCard from '../common/ActivityCard';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    height: '100%',
  },
  column: {
    flex: '1',
    padding: theme.spacing(4),
  },
}));

function RecommendationsTab(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const {
    recommendationsMostWatched,
    recommendationsUnwatchedProgram,
    recommendationsNewEpisodes,
  } = props;

  const filteredRecommendationsMostWatched = useMemo(
    () =>
      _.filter(
        recommendationsMostWatched.recommendations,
        recommendation => !_.isEmpty(recommendation.presentationTitle)
      ),
    [recommendationsMostWatched]
  );

  const filteredRecommendationsUnwatchedProgram = useMemo(
    () =>
      _.filter(
        recommendationsUnwatchedProgram.recommendations,
        recommendation => !_.isEmpty(recommendation.presentationTitle)
      ),
    [recommendationsUnwatchedProgram]
  );

  const filteredRecommendationsNewEpisodes = useMemo(
    () =>
      _.filter(
        recommendationsNewEpisodes.recommendations,
        recommendation => !_.isEmpty(recommendation.presentationTitle)
      ),
    [recommendationsNewEpisodes]
  );

  return (
    <Box id="RecommendationsTab-container" className={classes.container}>
      {_.isEmpty(filteredRecommendationsMostWatched) &&
      _.isEmpty(filteredRecommendationsUnwatchedProgram) &&
      _.isEmpty(filteredRecommendationsNewEpisodes) ? (
        <EmptyState variant="empty" message={t('activity.recommendationsEmpty')} />
      ) : (
        <>
          <Box className={classes.column}>
            <ActivityList
              id="RecommendationsTab-mostWatched"
              title={t('activity.recommendationsMostWatched')}
              activities={filteredRecommendationsMostWatched}
              renderActivity={(activity, activityId) => (
                <ActivityCard
                  activityId={activityId}
                  title={activity.presentationTitle}
                  subtitle={activity.presentationSubtitle || activity.title}
                  imageUrl={activity.imageUrl}
                  description={activity.description}
                  type={activity.type}
                />
              )}
              emptyContent={
                <EmptyState message={t('activity.recommendationsCategoryEmpty')} center={false} />
              }
            />
          </Box>
          <Box className={classes.column}>
            <ActivityList
              id="RecommendationsTab-unwatchedProgram"
              title={t('activity.recommendationsUnwatchedProgram')}
              activities={filteredRecommendationsUnwatchedProgram}
              renderActivity={(activity, activityId) => (
                <ActivityCard
                  activityId={activityId}
                  title={activity.presentationTitle}
                  subtitle={activity.presentationSubtitle || activity.title}
                  imageUrl={activity.imageUrl}
                  description={activity.description}
                  type={activity.type}
                />
              )}
              emptyContent={
                <EmptyState message={t('activity.recommendationsCategoryEmpty')} center={false} />
              }
            />
          </Box>
          <Box className={classes.column}>
            <ActivityList
              id="RecommendationsTab-newEpisodes"
              title={t('activity.recommendationsNewEpisodes')}
              activities={filteredRecommendationsNewEpisodes}
              renderActivity={(activity, activityId) => (
                <ActivityCard
                  activityId={activityId}
                  title={activity.presentationTitle}
                  subtitle={activity.presentationSubtitle || activity.title}
                  imageUrl={activity.imageUrl}
                  description={activity.description}
                  type={activity.type}
                />
              )}
              emptyContent={
                <EmptyState message={t('activity.recommendationsCategoryEmpty')} center={false} />
              }
            />
          </Box>
        </>
      )}
    </Box>
  );
}

RecommendationsTab.propTypes = {
  recommendationsMostWatched: PropTypes.shape({
    title: PropTypes.string,
    resultType: PropTypes.string,
    recommendations: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  recommendationsUnwatchedProgram: PropTypes.shape({
    title: PropTypes.string,
    resultType: PropTypes.string,
    recommendations: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  recommendationsNewEpisodes: PropTypes.shape({
    title: PropTypes.string,
    resultType: PropTypes.string,
    recommendations: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default RecommendationsTab;
